import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export const getAll = async (filters: any) => {
  let queryParams: string[] = [];

  if (filters) {
    if (filters.init_date) {
      queryParams.push(`init_date=${filters.init_date}`);
    }
    if (filters.end_date) {
      queryParams.push(`end_date=${filters.end_date}`);
    }
    if (filters.search) {
      queryParams.push(`search=${encodeURIComponent(filters.search)}`);
    }
    if (filters.status) {
      queryParams.push(`status=${encodeURIComponent(filters.status)}`);
    }
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  const response = await axios.get(`${API_URL}catalogos/portability${queryString}`);
  return response.data.doc.data;
};
export const sendPortability = async (values: any) => {
  const { id, nip, phoneFormat } = values;
  const response = await axios.post(`${API_URL}catalogos/portability/${id}/continue`, {
    nip: nip,
    numero_telefono: phoneFormat,
  });
  return response;
};

export const confirmStatus = async (id: number, statusId: number, comment?: string) => {
  const response = await axios.post(
    `${API_URL}catalogos/portability/changeStatus/`,
    {
      id: id,
      statusId: statusId,
      comment: comment || '',
    }
  );
  return response;
};

export const getStatuses = async () => {
  const response = await axios.get(`${API_URL}catalogos/portability/statuses`);
  const doc = response.data?.doc;
  return Array.isArray(doc) ? doc : (doc?.data || []);
};


export const exportPendingExcel = async () => {
  const response = await axios.get(`${API_URL}catalogos/portability/export-pending`, {
    responseType: 'blob',
  });
  const summaryHeader = response.headers['x-export-summary'];
  let summaryObj = null;
  if (summaryHeader) {
    try { summaryObj = JSON.parse(summaryHeader); } catch(e){}
  }

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'Solicitudes de portabilidad - ABD.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  
  return summaryObj;
};

export const exportABDTxt = async () => {
  const response = await axios.get(`${API_URL}catalogos/portability/export-abd`, {
    responseType: 'blob',
  });
  const summaryHeader = response.headers['x-export-summary'];
  let summaryObj = null;
  if (summaryHeader) {
    try { summaryObj = JSON.parse(summaryHeader); } catch(e){}
  }

  const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'Registros_ABD.txt');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  
  return summaryObj;
};

